module.exports = __webpack_public_path__ + "static/media/sh-ac.c8acbce0.svg";